import { useMutation, useQueryClient } from '@tanstack/react-query'
import { api } from '@api'
import { Scope } from '@utils'
import { showSuccessToast } from '@utils'
import { useLanguage } from '@context'

interface SendContactRequestData {
  recipientId: string
  scope: Scope
}

const sendContactRequest = async (data: SendContactRequestData): Promise<undefined> => {
  const { data: responseData } = await api.post<undefined>('/contact-requests', data)
  return responseData
}

export const useSendContactRequest = () => {
  const queryClient = useQueryClient()
  const { t } = useLanguage()

  return useMutation<undefined, Error, SendContactRequestData>({
    mutationFn: sendContactRequest,
    onSuccess: async () => {
      showSuccessToast(t('toast.contactRequestSent'), t('toast.contactRequestSentMessage'))
      await Promise.all([
        queryClient.invalidateQueries({
          queryKey: ['contacts-requested-sent'],
        }),
        queryClient.invalidateQueries({
          queryKey: ['contacts-suggested'],
        }),
      ])
    },
  })
}
